import React, { Component } from "react";
import { View, StyleSheet, Platform, TouchableHighlight } from "react-native";
import Text from "../../components_v2/TextFont";
import Theme from "../../argon-ui/Theme";
import FontAwesomeIcon from "../../components_v2/FontAwesomeIcon";
import { translate } from "../../locales/translate";
import PropTypes from "prop-types";
import { faTrash } from "../../../assets/consts/faCharCodes";
import Switch from "../../components/ToggleSwitch";
import InputBase from "../../nativeBase-ui/InputBase";
import Select from "../../nativeBase-ui/Select";
/**@augments{Component<Props,state>} */
class AreaStateAction extends Component {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    stateName: PropTypes.string,
    action: PropTypes.string,
    areaName: PropTypes.string,
    shouldOverrideAutoDisable: PropTypes.bool,
    overrideAutoDisableType: PropTypes.string,
    overrideAutoDisableDuration: PropTypes.number,
    onDelete: PropTypes.func,
    onOverrideAutoDisableChange: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.allIntervalTypes = ["second", "minute", "hour"];
    let {
      shouldOverrideAutoDisable,
      overrideAutoDisableType,
      overrideAutoDisableDuration,
    } = this.props;
    this.state = {
      shouldOverrideAutoDisable,
      overrideAutoDisableType,
      overrideAutoDisableDuration,
    };
  }

  handleOnOverrideAutoDisableChange = () => {
    let {
      shouldOverrideAutoDisable,
      overrideAutoDisableType,
      overrideAutoDisableDuration,
    } = this.state;
    typeof this.props.onOverrideAutoDisableChange == "function" &&
      this.props.onOverrideAutoDisableChange(
        shouldOverrideAutoDisable,
        overrideAutoDisableType,
        overrideAutoDisableDuration
      );
  };

  handleOnOverrideToggle = (val = false) => {
    this.setState({ shouldOverrideAutoDisable: val }, () => {
      this.handleOnOverrideAutoDisableChange();
    });
  };

  handleOnOverrideDuration = (type = "second", duration = 1) => {
    this.setState(
      {
        overrideAutoDisableType: type,
        overrideAutoDisableDuration: duration,
      },
      () => {
        this.handleOnOverrideAutoDisableChange();
      }
    );
  };

  render() {
    return (
      <View style={style.simpleRemovableWrapper}>
        <View style={{ flex: 1, flexDirection: "row",justifyContent:"space-between" }}>
          <View >
            <Text style={{ maxWidth: 200 }}>
              {translate("areaState.activateStateInArea", {
                area: this.props.areaName,
                state: this.props.stateName,
                action: translate(`scenario.actionsList.${this.props.action}`),
              })}
            </Text>
            <View style={style.row}>
              <Switch
                isOn={this.state.shouldOverrideAutoDisable}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={(v) => {
                  this.handleOnOverrideToggle(v);
                }}
                animationSpeed={0}
              />
              <Text style={[style.iosRtl, { fontSize: 11, marginHorizontal: 5 }]}>
                {translate("areaState.overrideAutoDisable")}
              </Text>
            </View>
          </View>
          <View style={{ marginHorizontal: 5, paddingTop: 1 }}>
            <TouchableHighlight
              underlayColor="transparent"
              style={{
                width: 35,
                height: 35,
                backgroundColor: Theme.COLORS.ERROR,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 5,
                marginTop: 5
              }}
              onPress={() => {
                this.props.onDelete && this.props.onDelete();
              }}
            >
              <FontAwesomeIcon icon={faTrash} color="#FFF" size={16} />
            </TouchableHighlight>
          </View>
        </View>

        {/* interval picker */}
        {this.props.shouldOverrideAutoDisable && (
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                width: 45,
                marginEnd: 5,
                color: Theme.COLORS.MUTED,
              }}
            >
              {translate("timer.after")}
            </Text>
            <InputBase
              containerStyle={{ width: 55, height: 40 }}
              keyboardType="numeric"
              onChangeText={(txt) => {
                var duration = Number(txt) || 0;
                this.handleOnOverrideDuration(
                  this.state.overrideAutoDisableType,
                  duration
                );
              }}
              value={this.state.overrideAutoDisableDuration.toString()}
            />
            <View style={{ flex: 1, marginHorizontal: 5 }}>
              <Select
                data={this.allIntervalTypes.map((v) => {
                  return { value: v, label: translate(`timer.${v}`) };
                })}
                value={
                  this.state.overrideAutoDisableType ||
                  this.allIntervalTypes[0]
                }
                onChangeText={(value, index, data) => {
                  this.handleOnOverrideDuration(
                    value,
                    this.state.overrideAutoDisableDuration
                  );
                }}
              />
            </View>
          </View>
        )}

      </View>
    );
  }
}

const style = StyleSheet.create({
  row: { flexDirection: "row", marginTop: 20 },
  simpleRemovableWrapper: {
    // flexDirection: "row",
    marginVertical: 5,
    padding: 5,
    // alignItems: "center",
    borderColor: Theme.COLORS.BORDER_COLOR,
    borderWidth: 2,
    borderRadius: 10,
    minHeight: 60,
    backgroundColor: Theme.COLORS.WHITE,
  },
  iosRtl: {
    textAlign: Platform.OS == "ios" ? "left" : "auto",
  },
});

export default AreaStateAction;
